/* SILKYFUN PDP V5: Shopify theme-safe interactions. No global header/footer hooks. */
(function () {
  'use strict';
  function init(scope) {
    (scope || document).querySelectorAll('[data-sf-m-hero]:not([data-sf-m-initialized])').forEach(function (root) {
      root.dataset.sfMInitialized = 'true';
      var photo = root.querySelector('[data-sf-m-main-photo]');
      var thumbs = Array.from(root.querySelectorAll('[data-sf-m-thumb]'));
      var current = 0;
      function show(index) {
        if (!photo || !thumbs.length) return;
        current = (index + thumbs.length) % thumbs.length;
        photo.src = thumbs[current].dataset.imageUrl;
        photo.alt = thumbs[current].dataset.imageAlt || '';
        thumbs.forEach(function (button, i) { button.classList.toggle('is-active', i === current); button.setAttribute('aria-pressed', String(i === current)); });
        var counter = root.querySelector('[data-sf-m-current]');
        if (counter) counter.textContent = String(current + 1).padStart(2, '0');
      }
      thumbs.forEach(function (button, index) { button.addEventListener('click', function () { show(index); }); });
      var prev = root.querySelector('[data-sf-m-prev]'), next = root.querySelector('[data-sf-m-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      var qty = root.querySelector('[data-sf-m-qty]');
      var minus = root.querySelector('[data-sf-m-minus]'), plus = root.querySelector('[data-sf-m-plus]');
      if (qty && minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (qty && plus) plus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + 1); });
      // Mobile introduction: clamp to two lines; only offer a toggle if it actually overflows.
      var intro = root.querySelector('[data-sf-m-intro]');
      var introToggle = root.querySelector('[data-sf-m-intro-toggle]');
      if (intro && introToggle) {
        root.classList.add('sf-m-js');
        var introLabel = introToggle.querySelector('[data-sf-m-intro-toggle-label]');
        var introMedia = window.matchMedia('(max-width: 767px)');
        function syncIntro() {
          intro.classList.remove('is-expanded');
          introToggle.setAttribute('aria-expanded', 'false');
          if (introLabel) introLabel.textContent = introToggle.dataset.moreLabel || 'Read more';
          if (!introMedia.matches) { introToggle.hidden = true; return; }
          // Compare heights with and without line-clamp; prevents a needless toggle on short text.
          var compactHeight = intro.getBoundingClientRect().height;
          intro.classList.add('is-expanded');
          var fullHeight = intro.getBoundingClientRect().height;
          intro.classList.remove('is-expanded');
          introToggle.hidden = fullHeight <= compactHeight + 2;
        }
        introToggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');
          introToggle.setAttribute('aria-expanded', String(expanded));
          if (introLabel) introLabel.textContent = expanded ? (introToggle.dataset.lessLabel || 'Show less') : (introToggle.dataset.moreLabel || 'Read more');
        });
        window.requestAnimationFrame(syncIntro);
        if (introMedia.addEventListener) introMedia.addEventListener('change', syncIntro);
        else if (introMedia.addListener) introMedia.addListener(syncIntro);
        // Re-check after a font swap and when a mobile viewport changes size.
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncIntro);
        if (window.ResizeObserver) {
          var introObserver = new ResizeObserver(function () { if (!intro.classList.contains('is-expanded')) syncIntro(); });
          introObserver.observe(root.querySelector('.sf-m-buy') || intro);
        }
      }
      var sel = root.querySelector('[data-sf-m-variant-select]'), price = root.querySelector('[data-sf-m-price]');
      var compare = root.querySelector('[data-sf-m-compare-price]');
      var add = root.querySelector('[data-sf-m-add]');
      if (sel) sel.addEventListener('change', function () {
        var selected = sel.selectedOptions[0];
        if (!selected) return;
        if (price) price.textContent = selected.dataset.price || price.textContent;
        if (compare) {
          var onSale = selected.dataset.onSale === 'true';
          compare.textContent = onSale ? (selected.dataset.comparePrice || '') : '';
          compare.hidden = !onSale;
        }
        if (add) {
          var available = selected.dataset.available === 'true';
          add.disabled = !available;
          var label = add.querySelector('[data-sf-m-add-text]');
          var icon = add.querySelector('[data-sf-m-add-icon]');
          if (label) label.textContent = available ? (add.dataset.addLabel || 'Add to bag') : 'Sold out';
          if (icon) icon.hidden = !available;
        }
      });
    });
    (scope || document).querySelectorAll('[data-sf-m-controls]:not([data-sf-m-initialized])').forEach(function (root) {
      root.dataset.sfMInitialized = 'true';
      var tabs = Array.from(root.querySelectorAll('[data-sf-m-control-tab]'));
      function activate(index) {
        tabs.forEach(function (tab, i) {
          var chosen = i === index;
          tab.setAttribute('aria-selected', String(chosen));
          tab.tabIndex = chosen ? 0 : -1;
          tab.classList.toggle('is-active', chosen);
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !chosen;
        });
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(index); });
        tab.addEventListener('keydown', function (ev) {
          if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
          ev.preventDefault();
          var next = (index + (ev.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(next); tabs[next].focus();
        });
      });
    });
    (scope || document).querySelectorAll('[data-sf-m-related]:not([data-sf-m-initialized])').forEach(function (root) {
      root.dataset.sfMInitialized = 'true';
      if (root.dataset.auto !== 'true') return;
      var productId = root.dataset.productId;
      var list = root.querySelector('[data-sf-m-related-list]');
      if (!productId || !list || !root.dataset.relatedUrl) return;
      var url = root.dataset.relatedUrl + '?section_id=' + encodeURIComponent(root.dataset.sectionId) + '&product_id=' + encodeURIComponent(productId) + '&limit=2&intent=related';
      fetch(url, { credentials: 'same-origin' }).then(function (res) { if (!res.ok) throw new Error('No recommendations'); return res.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sf-m-related-list]');
        if (fresh && fresh.querySelector('.sf-m-product-card')) list.innerHTML = fresh.innerHTML;
      }).catch(function () { /* Keep manually selected fallback products. */ });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
